<template>
  <nav>
    <ul class="leo2-pagination">
      <li v-if="total>0" :class="{'disabled': current == 1}">
        <a href="javascript:;" @click="setCurrent(current - 1)" class="btn_left"></a>
      </li>
      <li v-for="(p,index) in grouplist" :key="index" :class="{'active': current == p.val}">
        <a href="javascript:;" @click="setCurrent(p.val)"> {{ p.text }} </a>
      </li>
      <li v-if="total>0" :class="{'disabled': current == page}">
        <a href="javascript:;" @click="setCurrent(current + 1)" class="btn_right"></a>
      </li>
    </ul>
  </nav>
</template>

<script type="es6">
export default {
  data() {
    return {
      current: this.currentPage
    }
  },
  props: {
    total: {// 数据总条数
      type: Number,
      default: 0
    },
    display: {// 每页显示条数
      type: Number,
      default: 10
    },
    currentPage: {// 当前页码
      type: Number,
      default: 1
    },
    pagegroup: {// 分页条数
      type: Number,
      default: 5
    }
  },
  watch: {
    currentPage(val) {
      this.current = val;
    }
  },
  computed: {
    page: function () { // 总页数
      return Math.ceil(this.total / this.display);
    },
    grouplist: function () { // 获取分页页码
      var len = this.page, temp = [], list = [], count = Math.floor(this.pagegroup / 2),
        center = this.current;
      if (len <= this.pagegroup) {
        while (len--) {
          temp.push({ text: this.page - len, val: this.page - len });
        }
        return temp;
      }
      while (len--) {
        temp.push(this.page - len);
      }
      var idx = temp.indexOf(center);
      (idx < count) && (center = center + count - idx);
      (this.current > this.page - count) && (center = this.page - count);
      temp = temp.splice(center - count - 1, this.pagegroup);
      do {
        var t = temp.shift();
        list.push({
          text: t,
          val: t
        });
      } while (temp.length);
      return list;
    }
  },
  methods: {
    setCurrent: function (idx) {
      if (this.current != idx && idx > 0 && idx < this.page + 1) {
        this.current = idx;
        this.$emit('pagechange', this.current);
      }
    }
  }
}
</script>

<style lang="scss">
  .leo2-pagination {
    overflow: hidden;
    display: table;
    margin: 60px auto;
    height: 50px;

    li {
      list-style: none;
      float: left;
      height: 40px;
      border-radius: 40px;
      margin-right: 16px;
      color: #666;
      background-color: #f5f5f5;


      a {
        display: block;
        width: 40px;
        height: 40px;
        color: #666;
        text-align: center;
        line-height: 40px;
        font-size: 18px;
        border-radius: 40px;
        text-decoration: none;
      }

      .btn_left {
        background: url("../assets/images/btn_left.png") no-repeat center;
        background-size: 100%;
      }

      .btn_right {
        background: url("../assets/images/btn_right.png") no-repeat center;
        background-size: 100%;
      }
    }

    .active {
      background: #f44336;

      a {
        color: #fff;
      }

    }
  }

</style>
